export default (theme) => ({
  titleText: {
    marginBottom: 14,
    fontSize: 25,
    fontWeight: 'bold',
    color: '#014c94',
    [theme.breakpoints.down('sm')]: {
      fontSize: 19,
      marginBottom: 12,
    },
  },
  planBlock: {
    display: 'table-cell',
    textAlign: 'center',
    borderRight: '1px solid #808080',
    height: '100%',
    // verticalAlign: 'top',
    padding: '12px 6px 12px',
    '&:last-child': {
      borderRight: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      // borderRight: 'none',
      borderBottom: '1px solid #808080',
      '&:last-child': {
        borderBottom: 'none',
        borderRight: '1px solid #808080',
      },
    },
  },
  top: {
    padding: '24px 24px 0',
    [theme.breakpoints.down('sm')]: {
      borderRight: '1px solid #808080',
    },
  },
})
